import { AlertTriangle } from "lucide-react";
import type { Tuning } from "../data/instruments";
import { useI18n } from "../i18n/LocaleContext";

export function TuningWarningBadge({ tuning, testId = "warning-badge" }: { tuning: Tuning; testId?: string }) {
  const { t } = useI18n();

  if (!tuning.isApproximation) {
    return null;
  }

  return (
    <div className="warning-badge" data-testid={testId} role="note">
      <AlertTriangle size={16} aria-hidden="true" />
      <span>{tuning.warning ?? t.soundDna.approximationFallback}</span>
    </div>
  );
}
